<!-- Унифицирует обычные formatter-значения и formatter-компоненты ячеек таблицы. -->
<template>
  <!-- Обёртка не даёт стилям `.table-cell > span` перебить корневые стили компонента. -->
  <div v-if="componentListContent" class="table-cell-components">
    <component
      v-for="(item, index) in content"
      :key="item.key || index"
      :is="item.component"
      v-bind="item.props"
      @confirm-repair-inspection="$emit('confirm-repair-inspection', $event)"
    />
  </div>

  <div v-else-if="componentContent" class="table-cell-component">
    <component
      :is="content.component"
      v-bind="content.props"
      @confirm-repair-inspection="$emit('confirm-repair-inspection', $event)"
    />
  </div>

  <span v-else-if="column.formatter" v-html="content"></span>
  <span v-else>{{ value }}</span>
</template>

<script>
import FleetRepairInspectionStatusCell from "@/components/Table/cells/FleetRepairInspectionStatusCell.vue";
import OrderLinkCell from "@/components/Table/cells/OrderLinkCell.vue";
import DriverEntityLink from "@/components/Driver/DriverEntityLink.vue";
import UserIdentityCard from "@/components/User/UserIdentityCard.vue";
import UserEntityLink from "@/components/User/UserEntityLink.vue";
import VehicleEntityLink from "@/components/Vehicle/VehicleEntityLink.vue";
import VehicleRegNumberBadge from "@/components/Vehicle/VehicleRegNumberBadge.vue";

const FORMATTER_COMPONENTS = {
  DriverEntityLink,
  FleetRepairInspectionStatusCell,
  OrderLinkCell,
  UserIdentityCard,
  UserEntityLink,
  VehicleEntityLink,
  VehicleRegNumberBadge,
};

export default {
  name: "TableCellContent",

  components: FORMATTER_COMPONENTS,

  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },

  emits: ["confirm-repair-inspection"],

  computed: {
    value() {
      return this.item[this.column.key];
    },

    content() {
      if (!this.column.formatter) return this.value;

      return this.column.formatter(this.value, this.item);
    },

    componentContent() {
      return Boolean(
        this.content &&
          typeof this.content === "object" &&
          !Array.isArray(this.content) &&
          FORMATTER_COMPONENTS[this.content.component]
      );
    },

    componentListContent() {
      return Boolean(
        Array.isArray(this.content) &&
          this.content.length > 0 &&
          this.content.every(
            (item) =>
              item &&
              typeof item === "object" &&
              FORMATTER_COMPONENTS[item.component]
          )
      );
    },
  },
};
</script>

<style scoped>
.table-cell-component {
  display: flex;
  align-items: center;
}

.table-cell-components {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
</style>
